import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Typography,
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { deleteInputs } from "../functions";

const InputsDelete = ({ openDelete, setOpenDelete }) => {
  const dispatch = useDispatch();
  const { inputsIdSelected } = useSelector(({ inputs }) => inputs);
  const deleteFnc = async () => {
    await deleteInputs(inputsIdSelected)(dispatch);
    setOpenDelete(false);
  };
  return (
    <>
      <Dialog open={openDelete} onClose={() => setOpenDelete(false)}>
        <DialogTitle>
          <Typography variant="title">{"Eliminar"}</Typography>
        </DialogTitle>
        <DialogContent>
          <Typography variant="subtitle">
            {"Continuar con la Eliminación de la Entrada"}
          </Typography>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setOpenDelete(false)} color="primary">
            Cancelar
          </Button>
          <Button onClick={deleteFnc} color="primary">
            Eliminar
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
export default InputsDelete;
